import VueI18n, { TranslateResult } from "vue-i18n";
import { getDifferent } from "@/utils/index";
import Vue from "vue";
import zh_CN from "./zh-TW.json"
import en_US from "./en.json"

import locale from 'element-ui/lib/locale';
import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import enLocale from 'element-ui/lib/locale/lang/en'


Vue.use(VueI18n);

const LANG_MENU = {
    cn: "zh_CN",
    // tw: "zh_TW",
    en: "en_US"
};

// 获取当前语言
function getLang() {
    // 优先 去localstore
    if (localStorage.lang) {
        const lang = localStorage.lang;
        if (Object.keys(LANG_MENU).indexOf(lang) > -1)
            // eslint-disable-next-line
            return LANG_MENU[lang];
    } else {
        let language = null;
        if (navigator.appName == 'Netscape') {
            language = navigator.language;
        }
        else {
            language = navigator.browserLanguage;
        }

        if (language.indexOf("zh") > -1) {
            localStorage.setItem("lang", "cn")
            return "zh_CN"
        } else {
            localStorage.setItem("lang", "en")
            return "en_US"
        }
    }
    return "zh_CN";
}

const messages = {
    // zh_CN: require("@/locales/zh-cn/index.json"),
    zh_CN: {
        ...zh_CN,
        ...twLocale
    },
    en_US: {
        ...en_US,
        ...enLocale
    }
};

//对比语言包json属性
getDifferent(messages["zh_CN"], messages["en_US"]);

// delete messages["zh-cn"];

const i18n = new VueI18n({
    locale: getLang(),
    messages: messages,
    silentTranslationWarn: true
});

//兼容element
locale.i18n((key, value) => i18n.t(key, value));

// 设置当前语言
function setLang(lang) {
    Object.keys(LANG_MENU).forEach(key => {
        i18n.locale = lang;
        // eslint-disable-next-line
        if (LANG_MENU[key] === lang) localStorage.setItem("lang", key);
    });
}

export { getLang, setLang, i18n, TranslateResult };



// WEBPACK FOOTER //
// ./src/locales/index.js